import { Route, Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";
//Application global components
import ApplicationSetting from "./components/market/ApplicationSetting/ApplicationSetting";
import FAQ from "./components/market/FAQ/FAQ";
//
//Authorization Components
import AuthLayout from "./components/Layouts/authLayout/AuthLayout";
import Login from "./components/authorization/login/Login";
import Register from "./components/authorization/register/Register";
import AuthUserContext from "./context/AuthUserContext";
import RecoveryPass from "./components/authorization/recoveryPass/RecoveryPass";
//Market Components
import MarketLayout from "./components/Layouts/marketLayout/MarketLayout";
import Home from "./components/market/Home/Home";
import Trades from "./components/market/TradesList/Trades";
import BuyCoin from "./components/market/TradeCoin/BuyCoin";
import SellCoin from "./components/market/TradeCoin/SellCoin";
import DescCoin from "./components/market/AboutCoin/DescCoin";
import Convert from "./components/market/Convert/Convert";
import ConvertCustomPrice from "./components/market/Convert/ConvertCustomPrice";
import Wallet from "./components/market/Wallet/Wallet";
import TransferCoin from "./components/market/TransferCoin/TransferCoin";
import DepositCoin from "./components/market/DepositCoin/DepositCoin";
import Tickets from "./components/market/Tickets/Tickets";
import RecordTicket from "./components/market/Tickets/RecordTicket";
import TicketDescription from "./components/market/Tickets/TicketDescription";
//User-Profile components
import UserProfile from "./components/market/UserProfile/UserProfile";
import UserAccountInfo from "./components/market/UserProfile/UserAccountInfo/UserAccountInfo";
import IncreaseBalance from "./components/market/UserProfile/IncreaseBalance/IncreaseBalance";
import DecreaseUserBalance from "./components/market/UserProfile/DecreaseUserBalance/DecreaseUserBalance";
import CardsAccountInfo from "./components/market/UserProfile/CardsAccountInfo/CardsAccountInfo";
import Referral from "./components/market/UserProfile/Referral/Referral";
import RulesOfReferral from "./components/market/UserProfile/Referral/RulesOfReferral";
import ChangePassword from "./components/market/UserProfile/ChangePassword/ChangePassword";
import Transactions from "./components/market/UserProfile/Transactions/Transactions";
import ApplicationMessages from "./components/market/UserProfile/ApplicationMessages/ApplicationMessages";
//Authentication  components
import Authentication from "./components/market/UserProfile/Authentication/Authentication";
import PersonInfo from "./components/market/UserProfile/Authentication/PersonInfo";
import PersonCardId from "./components/market/UserProfile/Authentication/PersonCardId";
import PersonPic from "./components/market/UserProfile/Authentication/PersonPic";
import TwoFactor from "./components/market/UserProfile/Authentication/TwoFactor/TwoFactor";
import AuthGuid from "./components/market/UserProfile/Authentication/AuthGuid/AuthGuid";
import ApplicationGuid from "./components/market/ApplicationGuid/ApplicationGuid";
//Other Pages
import PaymentStatus from "./components/redirectPages/PaymentStatus";
import Logout from "./components/market/Logout/Logout";
import NotFound from "./components/404/NotFound";
//styles
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
//

function App() {
  const userCode = useSelector((state) => state.userId);
  const appTheme = useSelector((state) => state.appTheme);

  useEffect(() => {
    switch (appTheme) {
      case "light":
        document.body.classList.add(appTheme);
        document.body.classList.remove("dark");
        break;
      case "dark":
        document.body.classList.add(appTheme);
        document.body.classList.remove("light");
        break;
      default:
        break;
    }
  }, [appTheme]);
  return (
    <div>
      <ToastContainer rtl />
      <Switch>
        <Route path={["/authorization"]}>
          <AuthLayout>
            <AuthUserContext>
              <Switch>
                <Route
                  path="/authorization"
                  exact
                  render={() => <Redirect to="/authorization/login" />}
                />
                <Route
                  path="/authorization/register"
                  render={() =>
                    !isEmpty(userCode) && userCode.id !== "default" ? (
                      <Redirect to="/" />
                    ) : (
                      <Register />
                    )
                  }
                />
                <Route
                  path="/authorization/login"
                  render={() =>
                    !isEmpty(userCode) && userCode.id !== "default" ? (
                      <Redirect to="/" />
                    ) : (
                      <Login />
                    )
                  }
                />
                <Route
                  path="/authorization/recovery-pass"
                  render={() =>
                    !isEmpty(userCode) && userCode.id !== "default" ? (
                      <Redirect to="/" />
                    ) : (
                      <RecoveryPass />
                    )
                  }
                />
              </Switch>
            </AuthUserContext>
          </AuthLayout>
        </Route>
        <Route path={["/"]}>
          <MarketLayout>
            <Route
              path="/login"
              exact
              render={() => <Redirect to="/authorization/login" />}
            />
            <Switch>
              <Route path="/" exact render={() => <Home />} />
              <Route path="/trades-list" render={() => <Trades />} />
              <Route path="/buy/:name" render={() => <BuyCoin />} />
              <Route path="/sell/:name" render={() => <SellCoin />} />
              <Route
                path="/my-wallet"
                render={() =>
                  !isEmpty(userCode) ? (
                    <Wallet />
                  ) : (
                    <Redirect to="/authorization/login" />
                  )
                }
              />
              <Route path="/about-coin/:name" render={() => <DescCoin />} />
              <Route
                path="/withdraw/:name"
                render={() =>
                  !isEmpty(userCode) ? (
                    <TransferCoin />
                  ) : (
                    <Redirect to="/authorization/login" />
                  )
                }
              />
              <Route path="/deposit/:name" render={() => <DepositCoin />} />
              <Route path="/convert" render={() => <Convert />} />
              <Route
                path="/convert-custom"
                render={() => <ConvertCustomPrice />}
              />
              <Route
                path="/my-tickets"
                exact
                render={() =>
                  !isEmpty(userCode) ? (
                    <Tickets />
                  ) : (
                    <Redirect to="/authorization/login" />
                  )
                }
              />
              <Route
                path="/my-tickets/:id"
                render={() =>
                  !isEmpty(userCode) ? (
                    <TicketDescription />
                  ) : (
                    <Redirect to="/authorization/login" />
                  )
                }
              />
              <Route
                path="/record-ticket"
                render={() =>
                  !isEmpty(userCode) ? (
                    <RecordTicket />
                  ) : (
                    <Redirect to="/authorization/login" />
                  )
                }
              />
              <Route
                path="/my-profile"
                exact
                render={() =>
                  !isEmpty(userCode) ? (
                    <UserProfile />
                  ) : (
                    <Redirect to="/authorization/login" />
                  )
                }
              />
              <Route
                path="/my-profile/info"
                render={() =>
                  !isEmpty(userCode) ? <UserAccountInfo /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/increase-balance"
                render={() =>
                  !isEmpty(userCode) ? <IncreaseBalance /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/decrease-balance"
                render={() =>
                  !isEmpty(userCode) ? (
                    <DecreaseUserBalance />
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/my-profile/my-carts"
                render={() =>
                  !isEmpty(userCode) ? (
                    <CardsAccountInfo />
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/my-profile/referral"
                render={() =>
                  !isEmpty(userCode) ? <Referral /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/referral-rules"
                render={() => <RulesOfReferral />}
              />
              <Route
                path="/my-profile/change-pass"
                render={() =>
                  !isEmpty(userCode) ? <ChangePassword /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/transactions"
                render={() =>
                  !isEmpty(userCode) ? <Transactions /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/messages"
                render={() =>
                  !isEmpty(userCode) ? (
                    <ApplicationMessages />
                  ) : (
                    <Redirect to="/" />
                  )
                }
              />
              <Route
                path="/my-profile/authentication"
                exact
                render={() =>
                  !isEmpty(userCode) ? <Authentication /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/authentication/personal-info"
                render={() =>
                  !isEmpty(userCode) ? <PersonInfo /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/authentication/id-card"
                render={() =>
                  !isEmpty(userCode) ? <PersonCardId /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/authentication/person-pic"
                render={() =>
                  !isEmpty(userCode) ? <PersonPic /> : <Redirect to="/" />
                }
              />
              <Route
                path="/my-profile/authentication/2fa"
                render={() =>
                  !isEmpty(userCode) ? <TwoFactor /> : <Redirect to="/" />
                }
              />
              <Route path="/my-profile/auth-guid" render={() => <AuthGuid />} />
              <Route path="/app-guid" render={() => <ApplicationGuid />} />
              <Route path="/faq" render={() => <FAQ />} />
              <Route path="/setting" render={() => <ApplicationSetting />} />
              <Route
                path="/logout"
                render={() =>
                  !isEmpty(userCode) ? <Logout /> : <Redirect to="/" />
                }
              />
              <Route path="/payment-status" component={PaymentStatus} />
              <Route path="*" exact component={NotFound} />
            </Switch>
          </MarketLayout>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
